import { render, staticRenderFns } from "./classPri.vue?vue&type=template&id=a66528a4&scoped=true&"
import script from "./classPri.vue?vue&type=script&lang=js&"
export * from "./classPri.vue?vue&type=script&lang=js&"
import style0 from "./classPri.vue?vue&type=style&index=0&id=a66528a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66528a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
